const textProps = {
  title: "Our tools help you save 3 weeks of development...",
  description:
    "We’re not always in the position that we want to be at. We’re constantly growing. We’re constantly making mistakes. We’re constantly trying to express ourselves and actualize our dreams. If you have the opportunity to play this game of life you need to appreciate every moment. A lot of people don’t appreciate the moment until it’s passed.",
  icon: "fas fa-rocket",
  color: "emerald",
  image: require("assets/img/illustrations/500.svg").default,
  skew: {
    color: "light",
  },
};
export default textProps;
